import React, { Component } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles, Icon } from '@material-ui/core';
import { Button, Row, Col, Form, Container } from 'react-bootstrap';
import { ModalExibirLinkAcessoQuery } from '../../../graphql/Sessao';
import { Query, withApollo } from "react-apollo";
import { Link, withRouter } from "react-router-dom";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Swal from 'sweetalert2';
const { PUBLIC_URL } = process.env;

const classes = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    titulo: {
        fontSize: '25px',
        maxWidth: '500px',
        fontWeight: 'bold'
    },
    subtitulo: {
        marginBottom: '8px',
        fontSize: '15px'
    },
    buttonsActionWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    modalTitle: {
        paddingBottom: '10px',
    },
    rowUsuarios: {
        paddingTop: '5px',
        paddingBottom: '5px',
    },
    rowGrupos: {
        paddingTop: '5px',
        paddingBottom: '10px',
    },
    modalFooter: {
        paddingTop: '10px',
    },
    clipboardCopyIcon: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    rowConviteTitulo: {
        paddingTop: '15px',
    },
    rowConviteConteudo: {
        paddingTop: '5px',
        paddingBottom: '10px',
    },
});

class ExibirLinkAcesso extends Component {
    constructor(props) {
        super(props)

        this.state = {
            completeSessionUrl: null
        }

    }

    render() {
        const { classes, handleModalClose , sessionId, location } = this.props
        return (
            <Query query={ModalExibirLinkAcessoQuery} variables={{ sessionId }} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...';
                    if (error) return `Error! ${error.message}`;

                    const { sessaoOne } = data;
                    const { completeSessionUrl } = this.state;

                    if (!completeSessionUrl) {
                        setTimeout(() => {
                            this.setState({
                                completeSessionUrl: window.location.protocol + "//" + window.location.host+PUBLIC_URL+'/'+sessaoOne.slug
                            });
                        }, 10);
                        return null;
                    }

                    const prepareHtml = (completeSessionUrl) => {
                        return {__html: sessaoOne.texto_convite.replace("<p><br></p>", "").replace("{{LINK}}", `<a target="_blank" style="color: black; text-decoration: underline" href="${completeSessionUrl}">${completeSessionUrl}</a>`)};
                    }

                    return (
                        <Paper className={classes.root}>
                            <Container style={{minWidth: 500}}>
                                <Row>
                                    <Col className={classes.headerWrapper}>
                                        <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-sm btn-secondary-get">Fechar</Button>
                                    </Col>
                                </Row>

                                <Row className={classes.modalTitle}>
                                    <Col>
                                        <Typography className={classes.titulo}>{sessaoOne.nome}</Typography>
                                        <Typography className={classes.subtitulo}>Link de acesso</Typography>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={{offset: 1, span: 10}}>
                                        <Form.Control type="text" value={completeSessionUrl} readOnly></Form.Control>
                                    </Col>
                                    <Col sm="1" className={classes.clipboardCopyIcon} onClick={() => this.copyLinkToClipboard() }>
                                        <FileCopyIcon/>
                                    </Col>
                                </Row>

                                <Row className={classes.rowConviteTitulo}>
                                    <Col>
                                        <Typography className={classes.subtitulo}>Convite</Typography>
                                    </Col>
                                </Row>

                                <Row className={classes.rowConviteConteudo}>
                                    <Col sm={{offset: 1, span: 10}}>
                                        <div dangerouslySetInnerHTML={prepareHtml(completeSessionUrl)}></div>
                                    </Col>
                                </Row>
                            </Container>
                        </Paper>
                    );
                }}
            </Query>
        )
    }

    copyLinkToClipboard() {
        const { completeSessionUrl } = this.state;
        navigator.clipboard.writeText(completeSessionUrl);
        Swal.fire({
            title: "Link de acesso copiado",
            // text: "Link de acesso copiado",
            // icon: "info",
            timer: 1200,
            showCancelButton: false,
            showConfirmButton: false
        });
    }

}

export default withRouter(withStyles(classes)(ExibirLinkAcesso));